import { CheckBox, InHouseInputSelect } from '@celito.clients/shared';
import { Divider } from '@fluentui/react-components';
import { styles } from 'libs/core/src/providers/toast-provider/styles';
import { returnSelectedOptionFromOptions } from 'libs/core/src/utils/getSelectedOptionFromOptions';
import { IOption } from 'libs/shared/src/lib/in-house-input-select/in-house-input-select.model';
import { Controller, useFormContext } from 'react-hook-form';

import { RenderConditionsView } from './components/render-related-conditions/render-conditions.view';
import { RenderStages } from './components/render-stages/render-stages';
import { StateOfRelatedObjectsProps } from './state-of-related-objects.model';
import { StateOfRelatedObjectStyles } from './state-of-related-objects.styles';

interface StateOfRelatedObjectViewProps extends StateOfRelatedObjectsProps {
  appObjects: IOption[];
  comparisonOptions: IOption[];
  isInboundLoading: boolean;
}

export const StateOfRelatedObjectsView = ({
  index,
  appObjects,
  isInboundLoading,
  comparisonOptions,
  objectOptions,
  criteria,
  formPath,
}: StateOfRelatedObjectViewProps) => {
  const methods = useFormContext();
  const { control, watch, setValue } = methods;

  const watchedObject = watch(`${formPath}.${index}.validations.object`);
  const wathcedRelatedConditions = watch(
    `${formPath}.${index}.validations.isPerformOnConditions`
  );

  const styles = StateOfRelatedObjectStyles();

  return (
    <>
      <Controller
        name={`${formPath}.${index}.validations.object`}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <InHouseInputSelect
            label={'Objects'}
            options={appObjects}
            selectedOptions={returnSelectedOptionFromOptions(
              appObjects,
              field.value
            )}
            isLoadingOptions={isInboundLoading}
            onOptionSelect={(e, data) => {
              field.onChange(data.optionValue);

              if (data.data) {
                setValue(
                  `${formPath}.${index}.validations.relationshipName`,
                  data?.data.name
                );
                setValue(
                  `${formPath}.${index}.validations.relationShipType`,
                  data?.data.relationType
                );
              }
            }}
            required
            errorMessage={error?.message}
          />
        )}
      />

      <Controller
        name={`${formPath}.${index}.validations.comparision`}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <InHouseInputSelect
            label={'Comparison'}
            options={comparisonOptions}
            required
            selectedOptions={returnSelectedOptionFromOptions(
              comparisonOptions,
              field.value
            )}
            onOptionSelect={(e, data) => field.onChange(data.optionValue)}
            errorMessage={error?.message}
          />
        )}
      />

      <RenderStages
        index={index}
        objectName={watchedObject}
        formPath={formPath}
      />

      <div className={styles.performOnCondtions}>
        <Controller
          name={`${formPath}.${index}.validations.isPerformOnConditions`}
          control={control}
          render={({ field, fieldState: { error } }) => (
            <CheckBox
              onChanged={(e, data) => field.onChange(data?.checked)}
              label="Conditions On Related Objects"
              checked={field.value}
            />
          )}
        />

        {wathcedRelatedConditions && (
          <>
            <Divider />
            <RenderConditionsView
              index={index}
              formPath={`${formPath}.${index}.validations.conditions`}
              objectOptions={objectOptions}
            />
          </>
        )}
      </div>
    </>
  );
};
